import { Menu, MenuItem } from '../types/menu';
import { getDisplayText, getCategoryList } from './translationHelpers';

/**
 * Client-side twin of backend/utils/menuPlaintext.js.
 *
 * Builds a plain-text / lightly-Markdown rendering of a menu for the "Copy menu"
 * button on the experimental AI-assistant landing page, so a diner can paste the
 * menu into an assistant that ignores URL prefill.
 */

const UNCATEGORIZED = 'Other';

export function buildMenuText(menu: Menu, language: string = 'en'): string {
  if (!menu) return '';

  const restaurantName = menu.restaurant?.name || 'Menu';
  const lines: string[] = [`# ${restaurantName} — Menu`, ''];

  if (menu.restaurant?.description) {
    lines.push(menu.restaurant.description, '');
  }

  const items: MenuItem[] = (menu.menuPages || []).flatMap((page) => page.menuItems || []);

  const byCategory = new Map<string, MenuItem[]>();
  for (const item of items) {
    const categories = getCategoryList(item, language);
    const category = categories[0] || UNCATEGORIZED;
    if (!byCategory.has(category)) byCategory.set(category, []);
    byCategory.get(category)!.push(item);
  }

  const orderedCategories = Array.from(byCategory.keys()).sort((a, b) => a.localeCompare(b));

  for (const category of orderedCategories) {
    lines.push(`## ${category}`, '');
    for (const item of byCategory.get(category)!) {
      const name = getDisplayText(item, 'name', language) || '(unnamed item)';
      const price = item.price === null || item.price === undefined ? '' : String(item.price).trim();
      lines.push(price ? `- ${name} — ${price}` : `- ${name}`);
      const description = getDisplayText(item, 'description', language);
      if (description) {
        lines.push(`  ${description}`);
      }
    }
    lines.push('');
  }

  return lines.join('\n').trim() + '\n';
}
